<!--
 * @Description: 协议列表
 * @Author: maben
 * @Date: 2025-09-18 14:46:45
 * @LastEditors: maben
-->
<template>
    <div>
        <div class="bizcomp-change-card-list">
            <div class="bar-contain">
                <div class="bar"></div>
                <div class="bar-text">开户/风测类协议</div>
            </div>
            <el-table :data="agreementList" class="tab-list-tit table-list">
                <el-table-column prop="filename" label="协议名称" align="center">
                    <template slot-scope="scope">
                        <span style="cursor: pointer" v-on:click="openFile(scope.row.fileid)">
                            《{{ scope.row.filename }}》
                        </span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="bar-contain">
                <div class="bar"></div>
                <div class="bar-text">交易类协议</div>
            </div>
            <el-table :data="dataList" class="tab-list-tit table-list">
                <el-table-column prop="fundcode" label="产品代码" align="center" />
                <el-table-column prop="fundname" label="产品名称" align="center" />
                <el-table-column prop="filename" label="协议名称" align="center">
                    <template slot-scope="scope">
                        <span style="cursor: pointer" v-on:click="openFile(scope.row.filepath)">
                            《{{ scope.row.filename }}》
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import userApi from "@/api/user";

export default {
    name: "AgreementList",
    components: {},
    mixins: [mixin],
    data() {
        return {
            agreementList: [],
            dataList: []
        };
    },
    created() {
        this.getAgreementList();
        this.qryBusinessFile();
    },
    methods: {
        async getAgreementList(val = 1) {
            const res = await fundApi.queryCustAcctElecontractFile({
                fundpublishonflag: "1", // 查询上架产品的协议
                statusstr: "00,01,02,05,08,09", // 只查有效的,后端接口没办法吧这个状态字段写死
                pageSize: 100,
                pageNum: val
            });
            if (res.data) {
                this.dataList = res.data.data ? res.data.data : [];
            }
        },
        async qryBusinessFile() {
            const res = await fundApi.getProtocol({ policytype: "c,x" });
            if (res.data) {
                for (let i = 0; i < res.data.length; i++) {
                    this.agreementList.push({
                        filename: res.data[i].title,
                        fileid: res.data[i].fileid
                    });
                }
            }
        },
        openFile(fileCode) {
            window.open(this.$util.fileDownloadPath(fileCode));
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-change-card-list {
    width: 100%;
    background: #ffffff;
    box-sizing: border-box;
    margin-top: 13px;
    padding-bottom: 52px;
    overflow-x: hidden;

    .bar-contain {
        display: flex;
        align-items: center;
        margin: 36px 0 16px;
        &:first-child {
            margin-top: 0;
        }
        .bar {
            width: 3.71px;
            height: 16.73px;
            background: var(--color-primary);
        }
        .bar-text {
            margin-left: 6.29px;
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: 500;
            color: #333333;
        }
    }

    .table-list {
        width: 1160px;
        margin: auto;
        margin-top: 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
    }

    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
}
</style>
